import {
    ChevronLeft,
    ChevronRight
} from "lucide-react"

const TableFooter = ({
    startIndex,
    endIndex,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    totalDataCount,
}) => {
    const totalPages = Math.ceil(totalDataCount / itemsPerPage) || 1
    return (
        <div className="px-4 sm:px-6 py-3 sm:py-4 border-t-2 border-gray-300 bg-purple-50/30">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                <div className="flex items-center space-x-4 text-left">
                    <span className="text-xs sm:text-sm text-gray-700">
                        Showing <span className="font-semibold">{startIndex + 1}</span> to{' '}
                        <span className="font-semibold">{Math.min(endIndex, totalDataCount)}</span> of{' '}
                        <span className="font-semibold">{totalDataCount}</span> results
                    </span>
                </div>

                {/* Mobile-Responsive Pagination */}
                <div className="flex items-center justify-between sm:justify-end space-x-2">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        Previous
                    </button>

                    <div className="flex items-center space-x-1">
                        {/* Mobile: Show fewer page numbers */}
                        <div className="flex sm:hidden">
                            <span className="px-2 py-1 text-xs text-gray-600">
                                Page {currentPage} of {totalPages}
                            </span>
                        </div>

                        {/* Desktop: Show page numbers */}
                        <div className="hidden sm:flex items-center space-x-1">
                            {[...Array(Math.min(5, totalPages))].map((_, i) => {
                                const pageNum = i + 1;
                                const isActive = pageNum === currentPage;
                                return (
                                    <button
                                        key={pageNum}
                                        onClick={() => setCurrentPage(pageNum)}
                                        className={`px-3 py-2 text-sm rounded-lg transition-colors ${isActive
                                            ? 'bg-blue-600 text-white'
                                            : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
                                            }`}
                                    >
                                        {pageNum}
                                    </button>
                                );
                            })}
                            {totalPages > 5 && (
                                <>
                                    <span className="px-2 text-gray-500">...</span>
                                    <button
                                        onClick={() => setCurrentPage(totalPages)}
                                        className="px-3 py-2 text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                                    >
                                        {totalPages}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>

                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TableFooter
